import { render, staticRenderFns } from "./ManualCategoryModal.vue?vue&type=template&id=16489469"
import script from "./ManualCategoryModal.vue?vue&type=script&lang=js"
export * from "./ManualCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports